module.exports = __webpack_public_path__ + "static/media/om_faceshape_round_vector.60101ce8.svg";